import type { FC } from 'react';
import { SlackOauthInstallStrategyView } from './slack-oauth-install-strategy-view';
import { LinearOauthInstallStrategyView } from './linear-oauth-install-strategy-view';
import type { CredentialStrategyViewProps } from './credential-strategy-view-props';

/**
 * Override UI for specific `strategy.strategy.name` values (`t: 'custom'` only).
 * All other custom strategies use {@link UserProvidedStrategyView}.
 */
export const CUSTOM_CREDENTIAL_STRATEGY_VIEWS = {
  /** Matches {@link SlackOAuthStrategy} server `name`. */
  slack_oauth: SlackOauthInstallStrategyView,
  /** Matches {@link SlackBotAuthStrategy} server `name` (Coco install for search). */
  slack_auth: SlackOauthInstallStrategyView,
  /** Matches {@link LinearAgentOAuthStrategy} server `name` (Coco install for Linear). */
  linear_oauth: LinearOauthInstallStrategyView,
} satisfies Partial<Record<string, FC<CredentialStrategyViewProps>>>;
